import { Button, Col, Input, Row, Select } from 'antd';
import React, { ReactElement, useEffect } from 'react';
import { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  authFeatureConstants, FETCH_PACKAGE, GUTTOR_SPACE, HealthcheckpackageColumns, INVENTORY_MESSAGE_CONSTANTS, INVENTROY_CONSTANTS,
  PACKAGE_TYPE, StatusFilterType,
} from '../../../../shared/constants/commonConstants';
import { FetchPackageRequest, FetchPackageResponse } from '../../../../shared/models/packageDetail.model';
import SendRequest from '../../../../shared/services/sendRequest.service';
import { canActivate, error } from '../../../../utils/utility';
import HealthCheckList from './HealthCheckList';
import { extractSecondLevelBaseUrl } from './../../../../utils/utility';
import PageHeader from '../../../../shared/components/pageHeader/PageHeader';
import ApplicationDetail from '../../../../shared/services/applicationDetail.service';
import NoDataFound from '../../shared/NoDataFound';
import { FETCH_INVENTORY_DASHBOARD } from '../../../../shared/constants/urlEndPoints';
import { dashBoardRequest } from '../../../../store/actions/leftSideBarAction';
import { useDispatch } from 'react-redux';
import LoadTable from '../../shared/LoadTable';

const HealthCheckPackages = ({ match }: any): ReactElement => {
  let timeout: any;
  const pageNumber: any = new URLSearchParams(useLocation().search).get('page');
  const { Option } = Select;
  const history = useHistory();
  const [packageDetail, setPackageDetailHandler] = useState(null as any);
  const [filterType, setFilterType] = useState('Status');
  const [packageInput, setPackageInput] = useState(undefined as any);
  const [currentPage, setCurrentPage] = useState((pageNumber && pageNumber !== 'null') ? pageNumber : 1);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const profileId = ApplicationDetail.instance.getProfileId();
  const dispatch = useDispatch();
  const dashboardPayload: any = {
    title: INVENTORY_MESSAGE_CONSTANTS.title.healthCheckPackages,
    url: `${process.env.REACT_APP_INVENTORY_API_BASE_URL}${FETCH_INVENTORY_DASHBOARD}`, type: PACKAGE_TYPE.HEALTHCHECK,
  };
  const onPaginationData = (page: number, pagesize: number): any => {
    setCurrentPage(page);
    const reqpayload: FetchPackageRequest = {
      pageSize: pagesize,
      pageNumber: page,
      packageByProfileId: true,
      packageType: PACKAGE_TYPE.HEALTHCHECK,
      fetchInActiveRecord: true,
      profileIds: [profileId],
      packageByName: packageInput ? true : false,
      name: packageInput ? packageInput : '',
    };
    if (filterType !== '' && filterType !== 'Status') {
      reqpayload.statusType = filterType;
    }
    fetchPackages(reqpayload);
  };

  const fetchPackages = async (
    payload: any, isFlag?: boolean,
  ): Promise<any> => {
    dashboardPayload.filter = {
      departmentIds: undefined,
      name: payload?.name,
      statusName: payload?.statusType ? payload.statusType : 'NA',
    };
    if (!isFlag) {
      dispatch(dashBoardRequest(dashboardPayload));
    }
    const url = process.env.REACT_APP_INVENTORY_API_BASE_URL + FETCH_PACKAGE;
    const result: any = await SendRequest.instance.post<
      FetchPackageRequest,
      FetchPackageResponse
    >(url, payload);
    setIsDataLoaded(true);
    if (result && result.isSuccess) {
      setPackageDetailHandler(result);
    } else {
      setPackageDetailHandler(null);
      // tslint:disable-next-line: no-console
      error(INVENTORY_MESSAGE_CONSTANTS.healthCheckNotConfigured);
    }
  };
  useEffect((): void => {
    const reqpayload: FetchPackageRequest = {
      pageSize: 10,
      pageNumber: currentPage,
      packageByProfileId: true,
      packageType: PACKAGE_TYPE.HEALTHCHECK,
      fetchInActiveRecord: true,
      profileIds: [profileId],
    };
    fetchPackages(reqpayload, true);
    if (pageNumber) {
      removeQueryParam();
    }
  }, []);

  const removeQueryParam = (): void => {
    window.history.pushState('', '', window.location.pathname);
  };

  const newHCPackage = (): void => {
    history.push(extractSecondLevelBaseUrl(match?.path) + INVENTROY_CONSTANTS.hcNewPackageRoute);
  };

  const onFilterTypeSelected = (v?: any): any => {
    const reqpayload: FetchPackageRequest = {
      pageSize: 10,
      pageNumber: 1,
      packageByProfileId: true,
      packageType: PACKAGE_TYPE.HEALTHCHECK,
      fetchInActiveRecord: true,
      profileIds: [profileId],
      name: packageInput,
      packageByName: packageInput ? true : false,
    };

    clearTimeout(timeout);
    timeout = setTimeout((): void => {
      setCurrentPage(1);
      if (v) {
        setFilterType(v);
        switch (v) {
          case StatusFilterType.isApproved:
            reqpayload.statusType = StatusFilterType.isApproved;
            break;
          case StatusFilterType.isSubmit:
            reqpayload.statusType = StatusFilterType.isSubmit;
            break;
          case StatusFilterType.isRejected:
            reqpayload.statusType = StatusFilterType.isRejected;
            break;
          default:
            reqpayload.statusType = StatusFilterType.isDefault;
        }
        fetchPackages(reqpayload);
      } else {
        setFilterType('Status');
        reqpayload.statusType = StatusFilterType.isDefault;
        fetchPackages(reqpayload);
      }
    }, 500);
  };

  const onPackageNameSearch = (e: any): any => {
    if (e === null || e === undefined || e === '') {
      onClearInput();
      return;
    }
    clearTimeout(timeout);
    timeout = setTimeout((): void => {
      setPackageInput(e);
      setCurrentPage(1);
      const input: string = e || '';
      const reqpayload: FetchPackageRequest = {
        pageSize: 10,
        pageNumber: 1,
        packageByProfileId: true,
        packageType: PACKAGE_TYPE.HEALTHCHECK,
        fetchInActiveRecord: true,
        profileIds: [profileId],
        name: input,
        packageByName: true,
      };
      if (filterType !== '' && filterType !== 'Status') {
        reqpayload.statusType = filterType;
      }

      if (input && input.length >= 3) {
        fetchPackages(reqpayload);
      }
    }, 500);
  };

  const onClearInput = (): void => {
    setPackageInput(undefined);
    setCurrentPage(1);
    const reqpayload: FetchPackageRequest = {
      pageSize: 10,
      pageNumber: 1,
      packageByProfileId: true,
      packageType: PACKAGE_TYPE.HEALTHCHECK,
      fetchInActiveRecord: true,
      profileIds: [profileId],
    };
    if (filterType !== '' && filterType !== 'Status') {
      reqpayload.statusType = filterType;
    }
    fetchPackages(reqpayload);
  };

  return (
    <div>
      <PageHeader
        pageTitle="Health Check Packages"
        rightComponent={
          (): ReactElement =>
            <Row gutter={GUTTOR_SPACE}>
              <Col md={4} />
              <Col md={8}>
                <Select
                  style={{ width: '100%' }}
                  value={filterType}
                  allowClear={filterType === 'Status' ? false : true}
                  onClear={(): void => onFilterTypeSelected('')}
                  onSelect={onFilterTypeSelected}
                >
                  <Option value="APPROVED">Verified</Option>
                  <Option value="SUBMIT">Pending</Option>
                  <Option value="REJECTED">Rejected</Option>
                </Select>
              </Col>
              <Col md={8}>
                <Input placeholder="Search"
                  style={{ width: '100%' }}
                  allowClear={packageInput ? true : false}
                  ref={(input: any): any => input && input.focus()}
                  defaultValue={packageInput}
                  onChange={(e: any): void => onPackageNameSearch(e.target.value)}
                />
              </Col>
              {
                canActivate(authFeatureConstants.EDIT_HEALTH_CHECK_PACKAGES) &&
                <Col md={4}>
                  <div className="text-right"><Button type="primary" onClick={(): void => newHCPackage()} > + Add Package</Button></div>
                </Col>
              }
            </Row>}
      />
      <div className="ant-tabs-content-holder tab-custom-container">
        {(packageDetail && packageDetail.packages && isDataLoaded) &&
          <HealthCheckList onPaginationEvent={onPaginationData}
            currentPage={currentPage} packageItems={packageDetail.packages}
            totalRecords={packageDetail.totalRecords} match={match} />
        }
        {!packageDetail && isDataLoaded && <NoDataFound />}
        {!packageDetail && !isDataLoaded && <LoadTable columns={HealthcheckpackageColumns} />}
      </div>
    </div>
  );
};

export default HealthCheckPackages;
